var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6846 12C5.39434 12.0005 5.10684 11.9437 4.83861 11.8328C4.57038 11.7219 4.32671 11.5591 4.12159 11.3537L0 7.23286L1.042 6.19012L5.16359 10.3117C5.30179 10.4499 5.48919 10.5275 5.6846 10.5275C5.88 10.5275 6.06741 10.4499 6.2056 10.3117L16.5173 0L17.5593 1.042L7.2476 11.3537C7.04248 11.5591 6.79881 11.7219 6.53058 11.8328C6.26235 11.9437 5.97485 12.0005 5.6846 12Z",
    fill: "#008D06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/SuccessTick.fbd31df0da41a09856aeb26832ae75c4.svg";
export { ForwardRef as ReactComponent };